import { SearchClient } from 'algoliasearch';
import { SearchResponse, SearchOptions } from '@algolia/client-search';
import { AlgoliaIndiceName } from '@packages/common';

export type SearchBase = <T>(
  indiceName: AlgoliaIndiceName,
  queryParameters: SearchOptions,
) => Promise<SearchResponse<T>>;

// TODO: This function does not really require getAlgoliaClient parameter, but this breaks too many tests.
export function createSearchBase<T>(
  getAlgoliaClient: (indexName: AlgoliaIndiceName) => SearchClient,
  query = '',
): SearchBase {
  return ((indiceName, queryParameters) => {
    const index = getAlgoliaClient(indiceName).initIndex(indiceName);
    return index.search<T>(query, {
      ...queryParameters,
    }) as Promise<SearchResponse<T>>;
  }) as SearchBase;
}
